import * as types from '@/store/mutation-types';

const mutations = {
  [types.ADD_CONTENT_SLIDER_ITEM](state, p) {
    const drp = p.drp;
    drp.content.push(p.newContent);
  },
  [types.SET_CONTENT_SLIDER_LIMITS](state, p) {
    const drp = p.drp;
    drp.itemLimit = p.itemLimit;
    drp.showAll = p.showAll;
  },
  [types.REMOVE_CONTENT_SLIDER_ITEM](state, p) {
    const drp = p.drp;
    drp.content.splice(p.contIndex, 1);
  },
  [types.SET_CONTENT_SLIDER_DELAY](state, p) {
    const drp = p.drp;
    drp.delay = p.delay;
  },
  [types.SET_CONTENT_SLIDER_EFFECT](state, p) {
    const drp = p.drp;
    drp.effect = p.effect;
  },
  [types.SET_CONTENT_SLIDER_BULLETS](state, p) {
    const drp = p.drp;
    drp.bulletPosition = p.bulletPosition;
  },
  [types.SET_CONTENT_SLIDER_CONTROLS](state, p) {
    const drp = p.drp;
    drp.controls = p.controls;
  },
  [types.SET_CONTENT_SLIDER_FIRST](state, p) {
    const drp = p.drp;
    drp.firstUpload = p.value;
    // if changing to first upload, clear images
    if (p.value) {
      drp.content = [];
    }
  },
};

const actions = {
  addContentSliderItem: ({ commit }, payload) => {
    commit(types.ADD_CONTENT_SLIDER_ITEM, payload);
  },
  setContentSliderLimits: ({ commit }, payload) => {
    commit(types.SET_CONTENT_SLIDER_LIMITS, payload);
  },
  removeContentSliderItem: ({ commit }, payload) => {
    commit(types.REMOVE_CONTENT_SLIDER_ITEM, payload);
  },
  setContentSliderDelay: ({ commit }, payload) => {
    commit(types.SET_CONTENT_SLIDER_DELAY, payload);
  },
  setContentSliderEffect: ({ commit }, payload) => {
    commit(types.SET_CONTENT_SLIDER_EFFECT, payload);
  },
  setContentSliderBullets: ({ commit }, payload) => {
    commit(types.SET_CONTENT_SLIDER_BULLETS, payload);
  },
  setContentSliderControls: ({ commit }, payload) => {
    commit(types.SET_CONTENT_SLIDER_CONTROLS, payload);
  },
  setContentSliderFirst: ({ commit }, payload) => {
    commit(types.SET_CONTENT_SLIDER_FIRST, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/content-slider/vuex.js